import React from 'react';
import { Link, Text } from 'library';
import usePublicSessionTracking, { PublicSessionEventType } from 'parent-portal/shared/PublicSessionTracking';
import AppStoreButton from '../../AppStoreButton';
import AmbassadorPageLayout from '../AmbassadorPageLayout';
import Paragraph from '../Paragraph';
import Celebration from 'assets/images/celebration.png';
import Callout from '../Callout';

export default function AmbassadorErrorPage() {
    const { trackSession, usePageLoadTracking } = usePublicSessionTracking('Ambassador Error Page');
    usePageLoadTracking();

    function sendSupportEmail() {
        trackSession('NAVIGATE_FROM', 'Opened support email link', PublicSessionEventType.User);
        window.open('mailto:support@join-tandem.com');
    }

    return (
        <AmbassadorPageLayout>
            <Text variant="display" textStyle={{ marginBottom: 30, marginTop: 40 }}>
                Congratulations!
            </Text>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <CelebrateImage />
            </div>
            <Callout>Your Tandem account was created successfully!</Callout>
            <Paragraph>
                An error occurred when enrolling you in the ambassador program however. You may not have access to your
                ambassador dashboard in the app. If you cannot access the ambassador dashboard, send us an email at{' '}
                <Link onClick={sendSupportEmail}>support@join-tandem.com</Link> and we'll help you out.
            </Paragraph>
            <Callout>Download Tandem</Callout>
            <AppStoreButton tracking="Ambassador Error Page" />
        </AmbassadorPageLayout>
    );
}

function CelebrateImage() {
    return (
        <div
            style={{
                height: 135,
                width: 150,
                marginTop: 20,
                marginBottom: 40,
                backgroundImage: `url(${Celebration})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        />
    );
}
